export const handleCall = (phoneNumber = "+989216388036") => {
  if (/Mobi|Android/i.test(navigator.userAgent)) {
    window.location.href = `tel:${phoneNumber}`;
  } else {
    navigator.clipboard
      .writeText(phoneNumber)
      .then(() => alert("شماره تماس کپی شد!"))
      .catch(() => alert("خطا در کپی کردن شماره!"));
  }
};
